/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
export var OuiComboBoxTitle = ({
  children
}) => <div className="ouiComboBoxTitle">{children}</div>;
OuiComboBoxTitle.propTypes = {};
try {
  OuiComboBoxTitle.__docgenInfo = {
    tags: {},
    filePath: '/codebuild/output/src2210237963/src/src/components/combo_box/combo_box_options_list/combo_box_title.tsx',
    description: '',
    displayName: 'OuiComboBoxTitle',
    methods: [],
    props: {},
    extendedInterfaces: []
  };
} catch (e) {}